export interface QueryResponseState {
    fetchStatus: string
    isLoading: boolean
}

export function isQueryLoading(
    shouldFetch: boolean,
    response: QueryResponseState
) {
    return shouldFetch && response.fetchStatus !== 'idle' && response.isLoading
}
